import { Grid } from "@mui/material";
import React from "react";
import StockHeader from "./home/header";
import StockTabel from "./home/table";

const StockReport = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <StockHeader />
      </Grid>
      <Grid item xs={12}>
        <StockTabel />
      </Grid>
    </Grid>
  );
};

export default StockReport;
